import _ from 'lodash';

/* @ngInject */
export default function RcuService($q, $sails, $log) {
  const service = this;
  service.getRcuList = getRcuList;
  service.deleteRcu = deleteRcu;
  service.addNewRcu = addNewRcu;
  service.updateRcu = updateRcu;
  service.syncRcus = syncRcus;
  service.powerCycleCellular = powerCycleCellular;
  service.powerCycleEquipment = powerCycleEquipment;

  function getRcuList() {
    return $sails.get('/rcu/')
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function deleteRcu(rcuId) {
    return $sails.delete(`/rcu/${rcuId}`)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function addNewRcu(rcuObject) {
    return $sails.post('/rcu/', rcuObject)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function updateRcu(rcuId, obj) {
    const cloneObj = _.clone(obj);
    cloneObj.synchronized = false;
    delete cloneObj.equipment;
    return $sails.put(`/rcu/${rcuId}`, cloneObj)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function syncRcus(rcuId, force) {
    return $sails.post(`/rcu/syncRcu/${rcuId}`, { force })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function powerCycleCellular(rcuId) {
    return $sails.post(`/rcu/powerCycleCellular/${rcuId}`, {})
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function powerCycleEquipment(rcuId) {
    return $sails.post(`/rcu/powerCycleEquipment/${rcuId}`, {})
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }
}
